import { createNewElement, forcePageRefresh } from "../utils/functions";

const navbar = () => {
  const header = document.querySelector("header"),
    logo = document.querySelector(".nav__logo a img"),
    userIcon = "https://www.datocms-assets.com/76721/1697698822-icon-account.svg",
    cartIcon = "https://www.datocms-assets.com/76721/1697698829-icon-cart.svg";

  setInterval(() => {
    let crestElement = document.querySelector(".crest");

    // Add Header Logo
    if (!crestElement) {
      const crest = createNewElement("img", ["crest"]);
      crest.src = "https://www.datocms-assets.com/76721/1693377895-banfi_logo-crop.png";
      crest.alt = "header logo";
      document.querySelector(".site-nav__toggle").before(crest);
    } else {
      // Resize Header on Scroll
      window.onscroll = () => {
        if (window.innerWidth > 768) {
          if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
            header.style.maxHeight = "90px";
            header.style.padding = "0";
            crestElement.classList.add("scrolled");
            logo.classList.add("scrolled");
          } else {
            header.style.maxHeight = "140px";
            header.style.padding = "20px 0";
            crestElement.classList.remove("scrolled");
            logo.classList.remove("scrolled");
          }
        }
      };
    }

    const search = document.querySelector(".nav__account__search_icon__left");
    search.addEventListener("click", () => {
      const offcanvas = document.querySelector(".site-nav__menu");
      if (offcanvas.classList.contains("is-open")) {
        offcanvas.classList.remove("is-open");
      }
    });
    if (window.innerWidth < 768) {
      // Move search inside menu in mobile
      const container = document.querySelector(".site-nav__account");

      // Check if both elements exist before moving
      if (search && container) {
        // Check if search is not already a child of container
        if (!container.contains(search)) {
          container.appendChild(search);
        } else {
          console.log("Search is already a child of container.");
        }
      } else {
        console.error("Either search or container element not found.");
      }
    }

    // Replace Header Icons
    const userElement = document.querySelector(".auth__link"),
      userIconCheck = document.querySelector(".user-icon-replaced");

    if (userElement) {
      if (!userIconCheck) {
        replaceDefaultIcon(userIcon, userElement);
        userElement.classList.add("user-icon-replaced");
      }
    }

    const cartElement = document.querySelector(".cart__link"),
      cartIconCheck = document.querySelector(".cart-icon-replaced");

    if (cartElement) {
      if (!cartIconCheck) {
        replaceDefaultIcon(cartIcon, cartElement);
        cartElement.classList.add("cart-icon-replaced");
      }
    }
  }, 100);
};

export default navbar;

/**
 * Resize Header and Header Logo at Scroll
 *
 * @param html header
 * @param html logo
 */

// const resizeOnScroll = (header, logo) => {
//   let crest = document.querySelector(".site-nav .crest");
//   if (header && logo && crest) {
//     window.onscroll = () => {
//       if (window.innerWidth > 768) {
//         if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
//           header.style.maxHeight = "90px";
//           header.style.padding = "0";
//           crest.classList.add("scrolled");
//           logo.classList.add("scrolled");
//         } else {
//           header.style.maxHeight = "140px";
//           header.style.padding = "20px 0";
//           crest.classList.remove("scrolled");
//           logo.classList.remove("scrolled");
//         }
//       }
//     };
//   } else {
//     console.log("Missing params in function resizeOnScroll(header, logo)", [header, logo]);
//   }
// };

/**
 * Replace Default Icon
 *
 * @param string iconUrl
 * @param html element
 */

const replaceDefaultIcon = (iconUrl, element) => {
  if (iconUrl && element) {
    const icon = document.createElement("img");
    icon.src = iconUrl;
    icon.alt = "icon";
    icon.classList.add("header-icon");
    element.querySelector("svg").remove();
    element.append(icon);
  } else {
    console.log("Missing params in function replaceDefaultIcon(iconUrl, element)", [iconUrl, element]);
  }
};
